export enum WeekDays {
	mon,
	tue,
	wed,
	thu,
	fri,
	sat,
	sun,
}
